import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Theme } from "../styles/styles";
import { Box, Button, Checkbox, Link, Modal, Typography } from '@mui/material';
import { ThemeProvider } from "@mui/material/styles";

import { LabelLeftInput } from '../Atoms/LabelLeftInput';
import { AcceptConsent } from '../Atoms/AcceptConsent';
import { CustomizedCheckBoxGroup } from '../Atoms/CustomizedCheckBoxGroup';

import Privacy from '../Privacy/Privacy';
import {useEffect, useState} from "react";
//import useStore from './store';


export const NewLeadForm = ({ address, numOfOperators, radioList,
    piDataConsentText, conditionsConsentText, marketingConsentText,
    onCancel, onSave, isProcessing }) => {

    const [piChecked, setPiChecked] = React.useState(false);
    const [conditionsChecked, setConditionChecked] = React.useState(false);
    const [marketinChecked, setMarketingChecked] = React.useState(false);
    const [isSavePossible, setIsSavePossible] = React.useState(false);

    const [isOpenPrivacyModal, setIsOpenPrivacyModal] = React.useState(false);
    const [isOpenApprovalsModal, setIsOpenApprovalsModal] = React.useState(false);

    const [isEmailValidated, setIsEmailValidated] = React.useState(false);
    const [isPhoneValidated, setIsPhoneValidated] = React.useState(false);

    const handleClosePrivacyModal = () => setIsOpenPrivacyModal(false);
    const handleCloseApprovalsModal = () => setIsOpenApprovalsModal(false)

    const [errorMessage, setErrorMessage] = React.useState("");

    const [formState, setFormState] = useState({
            name: "",
            address: address,
            contactPhone: "",
            emailAddress: "",
            internet: false,
            tv: false,
            tel: false,
            biz: false,
            companyName: "",
            nip: "",
            service: "",
        }
    );

    useEffect(() => {
        console.log("useEffect NewLeadForm address");
        try {
            const savedData = localStorage.getItem("LeadFormData");
            if (null !== savedData) {
                console.log("useEffect NewLeadForm savedData", savedData);
                const parsedData = JSON.parse(savedData);
                console.log("useEffect NewLeadForm parsedData", parsedData);
                setFormState({ ...parsedData });
            }
        } catch (e) {
            console.error("Błąd podczas inicjalizacji domyślnego stanu formularza", e);
        }

    }, []);

    useEffect(() => {
        setIsSavePossible(piChecked && conditionsChecked && marketinChecked)
    }, [piChecked, conditionsChecked, marketinChecked]);

    const handlePiChange = (event) => {
        setPiChecked(event.target.checked);

    };

    const handleConditionChange = (event) => {
        setConditionChecked(event.target.checked);

    };

    const handleMarketingChange = (event) => {
        setMarketingChecked(event.target.checked);

    };

    const handleFormChange = (obj) => {
        console.log("handleFormChange", formState, obj);
        setFormState({
            ...formState,
            ...obj
        });
        console.log("handleFormChange", formState);
    };

    const handleAcceptApprovals = () => {
        setIsOpenApprovalsModal(false);

    }

    const handleSave = () => {
        const isEmailFilled = formState.emailAddress?.trim() !== "";
        const isPhoneFilled = formState.contactPhone?.trim() !== "";

        if (!isEmailFilled && !isPhoneFilled) {
            setErrorMessage("Proszę o wprowadzenie adresu e-mail lub numeru telefonu.");
            return;
        }

        console.log("handleSave", formState);
        setErrorMessage("");

        onSave(formState);
        console.log("handleSave", formState);
    };

    const handleClick = (event) => {
        event.preventDefault();
        setIsOpenApprovalsModal(true);
    };

    const updatedConditionsConsentText = (
        <span>
            {`Wyrażam zgodę na udostępnienie moich danych lokalnym operatorom telekomunikacyjnym, przygotowanie przez nich oferty dla mnie i kontakt ze mną. Oświadczam, że znam `}
            <Link href="#" onClick={handleClick}>
                Regulamin
            </Link>
            {` korzystania z Usług Portalu Lokalni.pl, w tym zasady przetwarzania danych osobowych opublikowane w `}
            <Link href="#" onClick={handleClick}>
                Polityce prywatności
            </Link>
            {`, akceptuję ich treść i przyjmuję do stosowania.`}
        </span>
    );

    const onFormKeyDown = (e) => {
        switch(e.key) {
            case 'Enter':
                if(!isSavePossible || isProcessing) {
                console.log("isSavePossible --> ", isSavePossible);
                console.log("isProcessing --> ", isProcessing);
                    e.preventDefault();
                }
                break;
        }
    };

    const nameKeyDown = (e) => {
        switch (e.key) {
            case 'Enter':
                e.preventDefault();
                break;
            default:
                // saveToLocalStorage();
        }
    }

    const addressKeyDown = (e) => {
        switch (e.key) {
            case 'Enter':
                e.preventDefault();
                break
            default:
        }
    }

    const phoneKeyDown = (e) => {
        switch (e.key) {
            case 'Enter':
                e.preventDefault();
                break;
            default:
        }
    }

    const emailKeyDown = (e) => {
        switch (e.key) {
            case 'Enter':
                e.preventDefault();
                break;
            default:
        }
    }

    return (
        <ThemeProvider theme={Theme}>
            <Box
                onKeyDown={onFormKeyDown}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "96%",
                    alignItems: "center",
                    justifyContent: "space-around",
                    minHeight: "1218px",
                    borderRadius: "16px",
                    backgroundColor: "#FFFFFF",
                    p: "12px",

                    [Theme.breakpoints.up("tablet")]: {
                        width: "90%",
                        minHeight: "779px",

                    },
                    [Theme.breakpoints.up("laptop")]: {
                        width: "90%",
                        minHeight: "781px",
                        p: "32px",
                    },
                    [Theme.breakpoints.up("desktop")]: {
                        width: "80%",
                        minHeight: "781px"
                    },

                }}
            >



                <Box sx={{ display: "flex", mb: "12px" }}>
                    <Typography variant="subtitle2" sx={{ fontSize: "18px", mr: "8px" }}>
                        Adres:
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontSize: "18px", color: "#2B46AF", }}>
                        {address ? address : ""}
                    </Typography>
                </Box>

                <Box id="tlo"
                    sx={{
                        width: "calc(100% + 24px)",
                        height: "78px",
                        backgroundColor: "#F2F3F5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "-12px",
                        marginRight: "-12px",
                        mb: "12px",
                        [Theme.breakpoints.up("laptop")]: {
                            width: "calc(100% + 64px)",
                            marginLeft: "-32px",
                            marginRight: "-32px",
                        },
                    }}>
                    <Typography variant="h4" sx={{ fontSize: "28px", textAlign: "center", }}>
                        Jesteś w zasięgu <span style={{ color: "#F49B00" }}>{numOfOperators}</span>
                        {numOfOperators < 2 ? " operatora" : " operatorów" }
                    </Typography>
                </Box>

                <Typography variant="subtitle2" sx={{ fontSize: "18px", mb: "12px" }}>
                    Jakiej usługi szukasz?
                </Typography>

                <Box sx={{ width: "100%" }}>
                    <CustomizedCheckBoxGroup checkboxList={radioList} changeHandler={handleFormChange} />
                </Box>
                <Typography variant="subtitle2" sx={{ fontSize: "18px", textAlign: "center", mb: "12px", }}>
                    Zostaw nam swoje dane,
                    a przygotujemy dla Ciebie
                    specjalną ofertę.
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "12px",
                        width: "100%",
                        mb: "16px"
                    }}
                >
                    <LabelLeftInput label="Twoje imię"
                                    placeholderText="np. Jan Kowalski"
                                    name="name"
                                    changeHandler={handleFormChange}
                                    inputText={formState.name}
                                    onInputKeyDown={nameKeyDown}
                    />
                    <LabelLeftInput label="Adres"
                                    name="address"
                                    changeHandler={handleFormChange}
                                    inputText={formState.address}
                                    onInputKeyDown={addressKeyDown}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            width: "100%",
                            [Theme.breakpoints.down("tablet")]: {
                                flexDirection: "column",
                                gap: "12px",
                            },
                            [Theme.breakpoints.up("tablet")]: {
                                flexDirection: "row",
                                justifyContent: "space-between",

                            },
                        }}

                    >
                        <Box
                            sx={{

                                [Theme.breakpoints.up("tablet")]: {
                                    width: "49%",

                                },
                            }}
                        >
                            <LabelLeftInput label="Telefon"
                                            placeholderText="np. 500 600 700"
                                            name="contactPhone"
                                            isEmail={false}
                                            isPhone={true}
                                            checkIsPhoneValidated={(prop) => setIsPhoneValidated(prop)}
                                            checkIsEmailValidated={(prop) => setIsEmailValidated(prop)}
                                            changeHandler={handleFormChange}
                                            inputText={formState.contactPhone}
                                            onInputKeyDown={phoneKeyDown}
                            />

                        </Box>
                        <Box
                            sx={{

                                [Theme.breakpoints.up("tablet")]: {
                                    width: "49%",

                                },
                            }}
                        >
                            <LabelLeftInput label="E-mail"
                                            placeholderText="np. jan.kowalski@lokalni.pl"
                                            name="emailAddress"
                                            isEmail={true}
                                            isPhone={false}
                                            checkIsPhoneValidated={(prop) => setIsPhoneValidated(prop)}
                                            checkIsEmailValidated={(prop) => setIsEmailValidated(prop)}
                                            changeHandler={handleFormChange}
                                            inputText={formState.emailAddress}
                                            onInputKeyDown={emailKeyDown}
                            />

                        </Box>

                    </Box>

                    {errorMessage && (
                        <Typography
                            variant="body2"
                            sx={{ color: "red", textAlign: "center", mb: "8px" }}
                        >
                            {errorMessage}
                        </Typography>
                    )}

                    {formState.biz &&
                        <LabelLeftInput label="Firma" placeholderText="..." name="companyName" changeHandler={handleFormChange} />
                    }

                    {formState.biz &&
                        <Box
                            sx={{
                                display: "flex",
                                width: "100%",
                                [Theme.breakpoints.down("tablet")]: {
                                    flexDirection: "column",
                                    gap: "12px",
                                },
                                [Theme.breakpoints.up("tablet")]: {
                                    flexDirection: "row",
                                    justifyContent: "space-between",

                                },
                            }}

                        >

                            <Box
                                sx={{

                                    [Theme.breakpoints.up("tablet")]: {
                                        width: "49%",

                                    },
                                }}
                            >
                                <LabelLeftInput label="NIP" placeholderText="..." name="nip" changeHandler={handleFormChange} />

                            </Box>
                            <Box
                                sx={{

                                    [Theme.breakpoints.up("tablet")]: {
                                        width: "49%",

                                    },
                                }}
                            >
                                <LabelLeftInput label="Usługa" placeholderText="np. transmisja danych" name="service" changeHandler={handleFormChange} />

                            </Box>

                        </Box>
                    }

                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", width: "100%", mb: "12px", alignItems: "flex-start", ml: "-14px" }}>
                    <AcceptConsent label={piDataConsentText} checked={piChecked} handleChange={handlePiChange} />
                    <AcceptConsent label={updatedConditionsConsentText} checked={conditionsChecked} handleChange={handleConditionChange} />
                    <AcceptConsent label={marketingConsentText} checked1={marketinChecked} handleChange={handleMarketingChange} />

                </Box>

                <Box sx={{ display: "flex", width: "100%", justifyContent: "center", mt: "12px", mb: "16px", }}>
                    <Button
                        onClick={() => {
                            onCancel();
                        }}
                        sx={{

                            ...Theme.outlinedOrangeButton,
                            [Theme.breakpoints.down("tablet")]: {
                                width: "145px"
                            },
                            [Theme.breakpoints.up("tablet")]: {
                                width: "151px"
                            },
                            [Theme.breakpoints.up("laptop")]: {
                                width: "166px",
                                fontSize: "22px",
                                fontWeight: 500,
                            },
                            mr: "12px"

                        }}
                    >
                        Anuluj
                    </Button>
                    <Button
                        onClick={() => {
                            handleSave();
                        }}
                        disabled={!isSavePossible}
                        sx={{
                            ...Theme.OrangeButton,
                            [Theme.breakpoints.down("tablet")]: {
                                width: "145px"
                            },
                            [Theme.breakpoints.up("tablet")]: {
                                width: "151px"
                            },
                            [Theme.breakpoints.up("laptop")]: {
                                width: "166px",
                                fontSize: "22px",
                                fontWeight: 500,
                            },

                        }}
                    >
                        Wyślij
                    </Button>
                </Box>

            </Box>
            <Modal
                open={isOpenPrivacyModal}
                onClose={handleClosePrivacyModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        position: "absolute",
                        borderRadius: "24px",
                        backgroundColor: "white",
                        paddingTop: "44px",
                        display: "flex",
                        flexDirection: "column",

                        [Theme.breakpoints.down("tablet")]: {
                            width: "90vw",
                        },
                    }}
                >
                    <Privacy />
                    <Button
                        onClick={() => {
                            handleClosePrivacyModal();
                        }}
                        sx={{
                            ...Theme.OrangeButton,
                            alignSelf: "flex-end",

                            mr: "44px",
                            mb: "44px",
                        }}
                    >
                        Zamknij
                    </Button>
                </Box>
            </Modal>
            <Modal
                open={isOpenApprovalsModal}
                onClose={handleCloseApprovalsModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        position: "absolute",
                        borderRadius: "24px",
                        backgroundColor: "white",
                        paddingTop: "44px",
                        display: "flex",
                        flexDirection: "column",

                        [Theme.breakpoints.down("tablet")]: {
                            width: "90vw",
                        },
                    }}
                >
                    <Privacy />
                    <Button
                        onClick={() => {
                            handleAcceptApprovals()
                        }}
                        sx={{
                            ...Theme.OrangeButton,
                            alignSelf: "flex-end",

                            mr: "44px",
                            mb: "44px",
                        }}
                    >
                        Zamknij
                    </Button>
                </Box>
            </Modal>
        </ThemeProvider >
    )
}